import { SwalMessage } from './Tools';

var AuthControl = (function () {
    // Hızlı giriş
    var QuickLogin = function () {
        var form = document.querySelector('[data-quick-login-form]');

        if (!form) {
            return;
        }

        // giriş yap butonu
        $(form).on('click', '[data-quick-login-submit]', function (event) {
            event.preventDefault();

            $(form).find('.invalid-feedback').empty();
            $(form).find('*').removeClass('is-invalid');
            $(form).find('.valid-feedback').empty();
            $(form).find('*').removeClass('is-valid');

            $.ajax({
                url: baseUrl + '/login',
                type: 'POST',
                dataType: 'json',
                data: $(form).serialize(),
                error: function error(xhr) {
                    $(form).find('.invalid-feedback').empty();
                    $(form).find('*').removeClass('is-invalid');

                    if (xhr.responseJSON && xhr.responseJSON.errors) {
                        $.each(xhr.responseJSON.errors, function (name, message) {
                            let element = form.querySelector('[name="' + name + '"]');
                            if (element) {
                                element.classList.add('is-invalid');
                                let valid = element.closest('div').querySelector('.invalid-feedback');
                                if (valid) {
                                    valid.style.display = 'block';
                                    valid.innerHTML = message;
                                }
                            }
                        });
                    }

                    // Genel hata mesajını göster
                    SwalMessage(
                        {
                            type: 'error',
                            text: xhr.responseJSON?.message || 'Giriş yapılırken bir hata oluştu. Lütfen tekrar deneyin.',
                            confirmButton: translate.ok_button || 'Tamam'
                        }
                    );
                },
                success: function success(xhr) {
                    if (xhr.two_factor) {
                        window.location.href = '/two-factor-challenge';
                    } else {
                        // location.reload();
                        window.location.href = '/orders';
                    }
                }
            });
        });
    };

    // Kayıt ol
    var Register = function () {
        var registerButton = document.querySelector('[register-button]');
        if (!registerButton) {
            return;
        }

        var form = registerButton.closest('form');

        // Register butonu tıklandığında
        registerButton.addEventListener('click', function (event) {
            event.preventDefault();

            // Hata ve başarı mesajlarını temizle
            $(form).find('.invalid-feedback').empty();
            $(form).find('*').removeClass('is-invalid');
            $(form).find('.valid-feedback').empty();
            $(form).find('*').removeClass('is-valid');

            // Form verilerini al
            var formData = $(form).serializeArray()

            // AJAX
            $.ajax({
                url: baseUrl + '/register',
                type: 'POST',
                dataType: 'json',
                data: formData,
                error: function error(xhr) {
                    $(form).find('.invalid-feedback').empty();
                    $(form).find('*').removeClass('is-invalid');
                    $.each(xhr.responseJSON.errors, function (name, message) {
                        let element = form.querySelector('[name="' + name + '"]');
                        if (element) {
                            element.classList.add('is-invalid');
                            let valid = element.closest('div').querySelector('.invalid-feedback');
                            if (valid) {
                                valid.style.display = 'block';
                                valid.innerHTML = message;
                            }
                        }
                    });

                    SwalMessage(
                      {
                          type: 'error',
                          text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                          confirmButton: translate.ok_button,
                      },
                      function () {
                        
                      }
                  );
                },
                success: function success(xhr) {
                    // Başarılı kayıt sonrası siparişler sayfasına yönlendir
                    window.location.href = '/orders';
                }
            });
        });
    };

    return {
        init: function () {
            QuickLogin();
            Register();
        }
    };
})();

$(function () {
    AuthControl.init();
});

// Example starter JavaScript for disabling form submissions if there are invalid fields
(() => {
    'use strict';

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.from(forms).forEach(form => {
        form.addEventListener(
            'submit',
            event => {
                if (!form.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                form.classList.add('was-validated');
            },
            false
        );
    });
})();
